module.exports = __webpack_public_path__ + "assets/img/show.2fb8e880.png";